'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dCredential$002dCount from "./presto.types$-Dashboard-Credential-Count.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DashboardCredentialCount$() {
}
export { $c_Lpresto_types$DashboardCredentialCount$ as $c_Lpresto_types$DashboardCredentialCount$ };
$p = $c_Lpresto_types$DashboardCredentialCount$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DashboardCredentialCount$;
/** @constructor */
function $h_Lpresto_types$DashboardCredentialCount$() {
}
export { $h_Lpresto_types$DashboardCredentialCount$ as $h_Lpresto_types$DashboardCredentialCount$ };
$h_Lpresto_types$DashboardCredentialCount$.prototype = $p;
$p.l = (function() {
  return "DashboardCredentialCount";
});
$p.cHo = (function(x$0) {
  return new $j_presto$002etypes$0024$002dDashboard$002dCredential$002dCount.$c_Lpresto_types$DashboardCredentialCount(x$0.j(0), (x$0.j(1) | 0), (x$0.j(2) | 0));
});
var $d_Lpresto_types$DashboardCredentialCount$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DashboardCredentialCount$, "presto.types$DashboardCredentialCount$", ({
  Zk: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$DashboardCredentialCount$ as $d_Lpresto_types$DashboardCredentialCount$ };
var $n_Lpresto_types$DashboardCredentialCount$;
function $m_Lpresto_types$DashboardCredentialCount$() {
  if ((!$n_Lpresto_types$DashboardCredentialCount$)) {
    $n_Lpresto_types$DashboardCredentialCount$ = new $c_Lpresto_types$DashboardCredentialCount$();
  }
  return $n_Lpresto_types$DashboardCredentialCount$;
}
export { $m_Lpresto_types$DashboardCredentialCount$ as $m_Lpresto_types$DashboardCredentialCount$ };
//# sourceMappingURL=presto.types$-Dashboard-Credential-Count$.js.map
